/**
 * Default BaB product-type filter to "Individual Packs".
 * Awtomic renders these checkboxes in a Chakra menu/drawer, so we click
 * the matching option once when filters first appear, then dismiss the UI.
 * While that runs, filter chrome is visually hidden to avoid a flash.
 *
 * Only runs on Build-a-Box pages (/tools/bundle-subscriptions/bundle/...),
 * not the customer portal (/tools/bundle-subscriptions?subscriptionId=...).
 */
(function () {
  var path = window.location.pathname || '';
  if (path.indexOf('/bundle-subscriptions/bundle/') === -1) return;

  var FILTER_LABEL = 'Individual Packs';
  var FILTER_VALUE = 'filter-1691702959060';
  var FILTERS_SELECTOR = '.awt-filters-container';
  var DRAWER_BODY = '.awt-filters-drawer-body';
  var CHECKBOX_LABEL = 'label.awt-filter-checkbox';
  var HIDING_CLASS = 'custom-bab-hiding-default-filter';
  var scheduled = false;
  var applied = false;
  var openingMenu = false;
  var closeTimer = null;
  var revealTimer = null;
  var closeAttempts = 0;
  var toggledButton = false;

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function setHiding(on) {
    document.documentElement.classList.toggle(HIDING_CLASS, !!on);
  }

  function findIndividualPacksLabel() {
    var labels = document.querySelectorAll(CHECKBOX_LABEL);
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      var input = label.querySelector('input[type="checkbox"]');
      var textEl = label.querySelector('.chakra-checkbox__label') || label;
      var matchesValue = input && input.value === FILTER_VALUE;
      var matchesText = normalize(textEl.textContent) === normalize(FILTER_LABEL);
      if (matchesValue || matchesText) return label;
    }
    return null;
  }

  function isChecked(label) {
    var input = label.querySelector('input[type="checkbox"]');
    if (!input) return false;
    if (input.checked || input.getAttribute('aria-checked') === 'true') return true;
    if (label.getAttribute('data-checked') != null) return true;
    var control = label.querySelector('.chakra-checkbox__control');
    return !!(control && control.getAttribute('data-checked') != null);
  }

  function getReactProps(el) {
    if (!el) return null;
    var keys = Object.keys(el);
    for (var i = 0; i < keys.length; i++) {
      if (
        keys[i].indexOf('__reactProps$') === 0 ||
        keys[i].indexOf('__reactEventHandlers$') === 0
      ) {
        return el[keys[i]];
      }
    }
    return null;
  }

  function invokeReactClick(el) {
    var props = getReactProps(el);
    if (!props || typeof props.onClick !== 'function') return false;
    props.onClick({
      target: el,
      currentTarget: el,
      preventDefault: function () {},
      stopPropagation: function () {},
      isDefaultPrevented: function () {
        return false;
      },
      isPropagationStopped: function () {
        return false;
      },
      persist: function () {},
      nativeEvent: new MouseEvent('click', { bubbles: true, cancelable: true, view: window }),
    });
    return true;
  }

  function dispatchEscape(target) {
    var opts = {
      key: 'Escape',
      code: 'Escape',
      keyCode: 27,
      which: 27,
      bubbles: true,
      cancelable: true,
    };
    (target || document).dispatchEvent(new KeyboardEvent('keydown', opts));
  }

  function findFilterTrigger() {
    var root = document.querySelector(FILTERS_SELECTOR);
    if (!root) return null;

    return (
      root.querySelector('button.awt-filter-button') ||
      root.querySelector('button.chakra-menu__menu-button') ||
      root.querySelector('button[aria-haspopup]') ||
      Array.prototype.find.call(root.querySelectorAll('button'), function (btn) {
        return !btn.classList.contains('awt-reset-filters-button');
      }) ||
      null
    );
  }

  function getFiltersPortal() {
    var drawerBody = document.querySelector(DRAWER_BODY);
    return drawerBody ? drawerBody.closest('.chakra-portal') : null;
  }

  function isDrawerOpen() {
    return !!document.querySelector(DRAWER_BODY);
  }

  function isMenuOpen() {
    var button = findFilterTrigger();
    return !!(button && button.getAttribute('aria-expanded') === 'true');
  }

  function revealWhenSettled() {
    if (revealTimer) clearTimeout(revealTimer);
    // Small delay so close animation / unmount finishes while still hidden
    revealTimer = setTimeout(function () {
      if (!isDrawerOpen() && !isMenuOpen()) {
        setHiding(false);
      }
    }, 80);
  }

  function closeFilterUi() {
    var button = findFilterTrigger();

    // Desktop Chakra menu
    if (button && button.getAttribute('aria-expanded') === 'true') {
      button.click();
      invokeReactClick(button);
    }

    if (!isDrawerOpen()) {
      revealWhenSettled();
      return;
    }

    // Mobile drawer: toggle the open trigger once
    if (button && !toggledButton) {
      toggledButton = true;
      button.click();
      invokeReactClick(button);
    }

    if (!isDrawerOpen()) {
      revealWhenSettled();
      return;
    }

    var portal = getFiltersPortal();
    var overlay = portal
      ? portal.querySelector('.chakra-modal__overlay')
      : document.querySelector('.chakra-modal__overlay');
    var dialog = document.querySelector(DRAWER_BODY);
    dialog = dialog && dialog.closest('[role="dialog"]');

    // Chakra often ignores synthetic .click(); call React onClick directly
    if (overlay) {
      invokeReactClick(overlay);
      overlay.click();
    }

    if (dialog) {
      try {
        dialog.focus();
      } catch (e) {}
      dispatchEscape(dialog);
      invokeReactClick(dialog);
    }
    dispatchEscape(document);

    closeAttempts += 1;
    if (closeAttempts < 8 && isDrawerOpen()) {
      closeTimer = setTimeout(closeFilterUi, 120);
      return;
    }

    revealWhenSettled();
  }

  function tryApply() {
    if (applied) return;
    if (!document.querySelector(FILTERS_SELECTOR)) return;

    // Hide filter chrome before we open/select to avoid a visible flash
    setHiding(true);

    var label = findIndividualPacksLabel();
    if (label) {
      if (!isChecked(label)) {
        label.click();
      }
      applied = true;
      openingMenu = false;
      closeAttempts = 0;
      toggledButton = false;
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closeFilterUi, 180);
      return;
    }

    // Menu/drawer items may not exist until the filter button is opened.
    if (openingMenu) return;
    var button = findFilterTrigger();
    if (!button) return;

    openingMenu = true;
    if (button.getAttribute('aria-expanded') !== 'true' && !isDrawerOpen()) {
      button.click();
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;

      if (!document.querySelector(FILTERS_SELECTOR)) {
        applied = false;
        openingMenu = false;
        closeAttempts = 0;
        toggledButton = false;
        setHiding(false);
        return;
      }

      tryApply();
    });
  }

  function init() {
    tryApply();

    var observer = new MutationObserver(schedule);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
